/* Pickld buy row (site uplift tranche 1b, partition H, 2026-09-10).

   One listener pair for every buy row on the page, wherever it was rendered
   from: snippets/pickld-buy-row.liquid in the homepage chart hero and New
   paddles, the rail cards (PDP add-on rail, page aside) and, on main, the old
   cart drawer's "Pair with" rows. Full doc: docs/components/buy-row.md.

   Delegated on `document`, not on a section root, because the rail can render
   twice on one product page and the drawer is a separate section again. The
   window flag binds exactly once no matter how many consumers load this file
   (the browser dedupes the request; it does not dedupe execution).

   The add goes through window.PickldCart.add(FormData): the Cart C4 drawer
   provides it on dev, the old cart drawer on main. No PickldCart, or a
   rejected add, sends the shopper to the product page (data-product-url).
   On success the row dispatches a bubbling "pickld:buy-added" event.

   The contract, all of it:
     [data-pickld-buy]                a buy row
     .pickld-buy__swatch              a choice, carries data-variant-id,
     .pickld-buy__select > option     data-value, data-price, data-compare, data-img
     [data-pickld-buy-add]            the add button, carries data-variant-id
     [data-pickld-buy-scope]          optional ancestor holding the row's
                                      thumbnail and price; the row itself when absent
     [data-pickld-buy-img] [data-pickld-buy-price]
     [data-pickld-buy-was] [data-pickld-buy-label]
     data-selling-plan                optional, on a choice or the add button:
                                      sent as selling_plan with the add (the STOQ
                                      deposit plan of a pre-order variant). Only
                                      emitted when the snippet is rendered with
                                      buy_preorder_plan (the homepage chart, 2026-10-18).
     data-preorder="1"                on a choice whose variant is a pre-order, and
     data-label-buy, data-label-pre,  on the add button: only when the snippet gets
     data-product-title               buy_label AND buy_preorder_plan. Every change
                                      then relabels the button "Pre-order" or "Buy now"
                                      (text, data-pickld-label, aria-label) for the
                                      chosen variant (Ben, 2026-10-18: a pre-order
                                      Smokey Quartz still said "Buy now"). Skipped
                                      while the button is disabled ("Adding...").

   The add button goes back to its OWN words after "Added" (kept in
   data-pickld-label on the first click), so a "Buy now" or "Pre-order"
   button never comes back as "+ Add".

   Quick add (2026-10-18, docs/components/quick-add.md). A tap on
     a[data-pickld-quick-add]         the snippet's "Choose options" ('choose' shape)
     a.pickld-chh__ad-choose          the chart hero's "Finish the kit" Choose
   opens a variant picker in place instead of the product page. Nothing loads
   with the page: the first tap (or a hover or focus just before it) injects
   assets/pickld-quick-add.js and assets/component-pickld-quick-add.css once,
   then calls window.PickldQuickAdd.open(link). Their URLs are printed by Liquid
   on the script tag that loads THIS file, as data-qa-js and data-qa-css (the
   real asset_url of each, so Shopify's own content hash is the cache buster and
   an edit to the picker or its stylesheet changes the URL by itself; the CDN
   keeps an asset URL for a year). Every tag that loads this file carries them;
   scripts/quick-add-harness/liquid-check.js (Q4) fails when one does not. A
   tag without them (an old consumer, the harness) falls back to this script's
   own address with the file name swapped, query kept. A modified click (new
   tab), a picker that will not load, or no JavaScript at all: the link's own
   href, the product page.
*/
(function () {
  if (window.pickldBuyRowBound) return;
  window.pickldBuyRowBound = true;

  /* ---------- quick add bootstrap ---------- */
  var QA_LINKS = 'a[data-pickld-quick-add], a.pickld-chh__ad-choose';
  var qaScript = document.currentScript;
  var qaSelf = (qaScript && qaScript.src) || '';
  var qaLoading = null;

  // The picker's URL for a file. attr is the data attribute Liquid prints on the
  // tag that loaded this script (data-qa-js or data-qa-css); name is the file, for
  // the fallback only. This tag first, then any tag on the page that has it.
  function qaUrl(attr, name) {
    var el = qaScript && qaScript.getAttribute && qaScript.getAttribute(attr) ? qaScript : document.querySelector('script[' + attr + ']');
    var printed = el ? el.getAttribute(attr) : '';
    if (printed) return printed;
    var base = qaSelf;
    if (!base) {
      var s = document.querySelector('script[src*="pickld-buy-row.js"]');
      base = s ? s.src : '';
    }
    if (!/pickld-buy-row\.js/.test(base)) return '';
    return base.replace(/pickld-buy-row\.js/, name);
  }

  function qaTag(tag, attrs) {
    return new Promise(function (resolve, reject) {
      var n = document.createElement(tag);
      Object.keys(attrs).forEach(function (k) { n[k] = attrs[k]; });
      n.onload = resolve;
      n.onerror = reject;
      document.head.appendChild(n);
    });
  }

  function qaReady() {
    if (window.PickldQuickAdd) return Promise.resolve(window.PickldQuickAdd);
    if (qaLoading) return qaLoading;
    var js = qaUrl('data-qa-js', 'pickld-quick-add.js'), css = qaUrl('data-qa-css', 'component-pickld-quick-add.css');
    if (!js || !css) return Promise.reject(new Error('quick add: no asset base'));
    qaLoading = Promise.race([
      Promise.all([qaTag('link', { rel: 'stylesheet', href: css }), qaTag('script', { src: js, async: true })]),
      new Promise(function (resolve, reject) { setTimeout(function () { reject(new Error('quick add: timed out')); }, 8000); })
    ]).then(function () {
      var m = window.PickldQuickAdd;
      if (!m) throw new Error('quick add: did not start');
      return m;
    });
    qaLoading.catch(function () { qaLoading = null; });   // the next tap tries again
    return qaLoading;
  }

  function qaOpen(link) {
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');
    qaReady().then(function (m) {
      link.removeAttribute('aria-busy');
      m.open(link);
    }, function () {
      link.removeAttribute('aria-busy');
      window.location.href = link.href;
    });
  }

  // Warm the picker on intent (a pointer over a Choose link, or focus on it), so the tap opens at once.
  function qaWarm(e) {
    if (window.PickldQuickAdd || qaLoading) return;
    if (e.target && e.target.closest && e.target.closest(QA_LINKS)) qaReady().catch(function () {});
  }
  document.addEventListener('pointerover', qaWarm, { passive: true });
  document.addEventListener('focusin', qaWarm);

  function sync(row, el) {
    var scope = row.closest('[data-pickld-buy-scope]') || row;
    var d = el.dataset;
    var add = row.querySelector('[data-pickld-buy-add]');
    if (add && d.variantId) add.dataset.variantId = d.variantId;
    if (add) {
      if (d.sellingPlan) add.dataset.sellingPlan = d.sellingPlan;
      else delete add.dataset.sellingPlan;
      // The button says what it will do for the chosen variant (Ben, 2026-10-18).
      if (add.dataset.labelBuy && !add.disabled) {
        var words = d.preorder ? add.dataset.labelPre : add.dataset.labelBuy;
        add.textContent = words;
        add.setAttribute('data-pickld-label', words);
        add.setAttribute('aria-label', words + ', ' + (add.dataset.productTitle || ''));
      }
    }
    var img = scope.querySelector('[data-pickld-buy-img]');
    if (img && d.img) {
      img.src = d.img;
      img.removeAttribute('srcset');
    }
    var price = scope.querySelector('[data-pickld-buy-price]');
    if (price && d.price) price.textContent = d.price;
    var was = scope.querySelector('[data-pickld-buy-was]');
    if (was) {
      was.textContent = d.compare || '';
      was.hidden = !d.compare;
    }
    var label = scope.querySelector('[data-pickld-buy-label]');
    if (label && d.value) label.textContent = d.value;
  }

  // Keep the chosen swatch visible in an inline strip without scrolling the page.
  function keepInView(swatch) {
    var strip = swatch.parentElement;
    if (!strip || strip.scrollWidth <= strip.clientWidth) return;
    strip.scrollLeft = swatch.offsetLeft - (strip.clientWidth - swatch.offsetWidth) / 2;
  }

  document.addEventListener('click', function (e) {
    var qa = e.target.closest(QA_LINKS);
    if (qa) {
      // a new-tab click, or a handler before us that took it: the link does its own thing
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      qaOpen(qa);
      return;
    }

    var swatch = e.target.closest('.pickld-buy__swatch');
    if (swatch) {
      if (swatch.classList.contains('is-unavailable')) return;
      var swatchRow = swatch.closest('[data-pickld-buy]');
      if (!swatchRow) return;
      swatchRow.querySelectorAll('.pickld-buy__swatch').forEach(function (b) {
        var on = b === swatch;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      sync(swatchRow, swatch);
      keepInView(swatch);
      return;
    }

    var btn = e.target.closest('[data-pickld-buy-add]');
    if (!btn || btn.disabled) return;
    var row = btn.closest('[data-pickld-buy]');
    if (!row) return;
    var select = row.querySelector('.pickld-buy__select');
    var chosen = select ? select.options[select.selectedIndex] : null;
    var variantId = select ? select.value : btn.dataset.variantId;
    if (!variantId) return;
    // The selected option is the truth for a select (a restored form value
    // never fired "change"); the button carries it for swatches and singles.
    var plan = chosen ? chosen.dataset.sellingPlan : btn.dataset.sellingPlan;

    if (!btn.hasAttribute('data-pickld-label')) btn.setAttribute('data-pickld-label', btn.textContent);
    var label = btn.getAttribute('data-pickld-label');
    var reset = function () {
      btn.disabled = false;
      btn.textContent = label;
    };
    if (!window.PickldCart) {
      window.location.href = row.dataset.productUrl;
      return;
    }
    btn.disabled = true;
    btn.textContent = 'Adding...';
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    if (plan) fd.append('selling_plan', plan);
    window.PickldCart.add(fd)
      .then(function () {
        btn.textContent = 'Added';
        setTimeout(reset, 1600);
        // Consumers may react (the cart drawer removes the pair-with row).
        row.dispatchEvent(new CustomEvent('pickld:buy-added', { bubbles: true, detail: { variantId: variantId } }));
      })
      .catch(function () {
        reset();
        window.location.href = row.dataset.productUrl;
      });
  });

  document.addEventListener('change', function (e) {
    var select = e.target.closest('.pickld-buy__select');
    if (!select) return;
    var row = select.closest('[data-pickld-buy]');
    var opt = select.options[select.selectedIndex];
    if (row && opt) sync(row, opt);
  });

  function init() {
    document.querySelectorAll('.pickld-buy--inline .pickld-buy__swatches .is-active').forEach(keepInView);
    // With this script running, a Choose link opens a dialog (without it, the product page).
    document.querySelectorAll(QA_LINKS).forEach(function (a) { a.setAttribute('aria-haspopup', 'dialog'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
